import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useState, useEffect } from 'react';
import { getUserInfo, initHost, initUserProfileApi } from '../api';
import { initDataFormatFactory } from './formatFactoryTool';
import Profile from './MyProfile';
import Security from './Security';
import Themes from './Themes';
import CommonLoad from '../../Basic/Spin';
import { IconSecurity, IconThemes, IconMyProfile, IconFeatureReset } from '@sfx/icons';
import Modal from '../../Basic/Modal';
import { getTransFunc } from '../../Basic/SFxLocalization';

import { notifyErrorToast } from '../utils/errorToast';
var prefix = 'sfx-react-ui-user-preferences';

var showConfirm = function showConfirm(onOKCallback) {
  var trans = getTransFunc();
  var title = trans('SFxUserPreferencesResetLayoutTitle');
  var content = /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-confirm-content")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-confirm-content-title")
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-confirm-content-text")
  }, trans('SFxUserPreferencesResetLayoutConfirm')));
  Modal.confirm({
    title: title,
    content: content,
    className: "".concat(prefix, "-confirm-modal"),
    cancelText: trans('SFxUserPreferencesResetLayoutCancelButton'),
    okText: trans('SFxUserPreferencesResetLayoutOkButton'),
    centered: true,
    onOk: function onOk() {
      if (onOKCallback) onOKCallback();
    }
  });
};

var UserPreferences = function UserPreferences(props) {
  var trans = getTransFunc();
  var menuListDefault = [{
    id: 1,
    icon: IconMyProfile,
    name: 'SFxUserPreferencesMenuProfileText',
    component: Profile
  }, {
    id: 2,
    icon: IconSecurity,
    name: 'SFxUserPreferencesMenuSecurityText',
    component: Security
  }, {
    id: 3,
    icon: IconThemes,
    name: 'SFxUserPreferencesMenuThemeText',
    component: Themes
  }];

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      menuList = _useState2[0],
      setMenuList = _useState2[1];

  var _useState3 = useState(menuList[0]),
      _useState4 = _slicedToArray(_useState3, 2),
      activeMenu = _useState4[0],
      setActiveMenu = _useState4[1];

  var _useState5 = useState({
    currentAvatar: '',
    profile: {},
    userId: ''
  }),
      _useState6 = _slicedToArray(_useState5, 2),
      userData = _useState6[0],
      setUserData = _useState6[1];

  var _useState7 = useState(true),
      _useState8 = _slicedToArray(_useState7, 2),
      showLoading = _useState8[0],
      setShowLoading = _useState8[1];

  var onClickResetSettings = function onClickResetSettings() {
    showConfirm(function () {
      props.userPreferencesCallback(_objectSpread({
        resetLayoutSettings: true
      }, userData));
    });
  };

  useEffect(function () {
    var _props$showMenulist = props.showMenulist,
        showMenulist = _props$showMenulist === void 0 ? [] : _props$showMenulist,
        options = props.options;

    if (options) {
      initHost(options);
      initUserProfileApi(options);
    }

    var filterMenuList = function filterMenuList() {
      var filteredMenuList = menuListDefault.filter(function (item, index) {
        return showMenulist[index] === true;
      });

      var _filteredMenuList = _slicedToArray(filteredMenuList, 1),
          currentMenu = _filteredMenuList[0];

      setMenuList(filteredMenuList);
      setActiveMenu(currentMenu);
    };

    filterMenuList();

    var getUserProfile = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _options, _userData, _yield$getUserInfo, data, _userData2;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _options = props.options;

                if (!_options.initialData) {
                  _context.next = 8;
                  break;
                }

                _userData = initDataFormatFactory(_options.initialData, _options.staticSource);
                setUserData(_userData);
                setShowLoading(false);
                _context.next = 16;
                break;

              case 8:
                _context.next = 10;
                return getUserInfo({
                  catchError: true
                });

              case 10:
                _yield$getUserInfo = _context.sent;
                data = _yield$getUserInfo.data;
                _userData2 = initDataFormatFactory(data, _options.staticSource);
                setUserData(_userData2);
                setShowLoading(false);
                props.userPreferencesCallback(_objectSpread({
                  getUserProfileSuccess: 'success'
                }, _userData2));

              case 16:
                _context.next = 22;
                break;

              case 18:
                _context.prev = 18;
                _context.t0 = _context["catch"](0);
                setShowLoading(false);
                notifyErrorToast(trans('SFxAccountSettingsUserProfileFetchError'), _context.t0);

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 18]]);
      }));

      return function getUserProfile() {
        return _ref.apply(this, arguments);
      };
    }();

    getUserProfile(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  var userPreferencesCallback = function userPreferencesCallback(_ref2) {
    var currentUserData = _ref2.currentUserData,
        restProps = _objectWithoutProperties(_ref2, ["currentUserData"]);

    if (currentUserData) {
      var newData = _objectSpread(_objectSpread({}, userData), currentUserData);

      setUserData(newData);
    }

    if (props.userPreferencesCallback) {
      props.userPreferencesCallback(restProps);
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, showLoading && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-mask")
  }, /*#__PURE__*/React.createElement(CommonLoad, {
    size: 0.2
  })), activeMenu && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-title-sm-screen")
  }, trans('SFxUserPreferencesTitle')), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-wrap")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-left")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-left-title")
  }, trans('SFxUserPreferencesTitle')), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-menu-list")
  }, menuList.map(function (item, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: "".concat(prefix, "-menu-item ").concat(activeMenu && activeMenu.id === item.id ? 'active' : ''),
      onClick: function onClick() {
        setActiveMenu(item);
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefix, "-menu-item-icon")
    }, /*#__PURE__*/React.createElement(item.icon, {
      size: 16
    })), /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefix, "-menu-item-text")
    }, trans(item.name)));
  })), !props.disabledResetLayout && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-menu-item ").concat(prefix, "-settings"),
    onClick: onClickResetSettings
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefix, "-menu-item-icon")
  }, /*#__PURE__*/React.createElement(IconFeatureReset, {
    size: 16
  })), /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefix, "-menu-item-text")
  }, trans('SFxUserPreferencesRestLayoutMenu')))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-right")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-right-title")
  }, activeMenu && activeMenu.name && trans(activeMenu.name)), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-right-box")
  }, activeMenu && activeMenu.component && /*#__PURE__*/React.createElement(activeMenu.component, {
    prefix: prefix,
    userPreferencesCallback: userPreferencesCallback,
    staticSource: props.options.staticSource || {},
    userData: userData,
    options: props.options,
    isShowAvatar: props.isShowAvatar === undefined ? true : props.isShowAvatar,
    disabledResetLayout: props.disabledResetLayout,
    myProfileChildrenNode: props.myProfileChildrenNode,
    securityChildrenNode: props.securityChildrenNode,
    trans: trans
  }))))));
};

export default UserPreferences;